import { render } from "./OpportunityCard.vue?vue&type=template&id=2c1e9ebe&scoped=true"
import script from "./OpportunityCard.vue?vue&type=script&lang=js"
export * from "./OpportunityCard.vue?vue&type=script&lang=js"

import "./OpportunityCard.vue?vue&type=style&index=0&id=2c1e9ebe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1e9ebe"]])

export default __exports__